// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ItemsSelectQueryVariables = Types.Exact<{
  filter: Types.ItemFilter;
}>;


export type ItemsSelectQuery = { __typename?: 'Query', items: Array<{ __typename?: 'Item', id: string, name: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string }, tradeCategory?: { __typename?: 'TradeCategory', id: string, displayName: string } | null | undefined }> };

export type ItemsDataFragment = { __typename?: 'Item', id: string, name: string, fullCode: string, costCode: { __typename?: 'CostCode', id: string, displayName: string }, tradeCategory?: { __typename?: 'TradeCategory', id: string, displayName: string } | null | undefined };

export const ItemsDataFragmentDoc = gql`
    fragment itemsData on Item {
  id
  name
  fullCode
  costCode {
    id
    displayName
  }
  tradeCategory {
    id
    displayName
  }
}
    `;
export const ItemsSelectDocument = gql`
    query ItemsSelect($filter: ItemFilter!) {
  items(filter: $filter) {
    ...itemsData
  }
}
    ${ItemsDataFragmentDoc}`;

/**
 * __useItemsSelectQuery__
 *
 * To run a query within a React component, call `useItemsSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemsSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemsSelectQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useItemsSelectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ItemsSelectQuery, ItemsSelectQueryVariables> & ({ variables: ItemsSelectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ItemsSelectQuery, ItemsSelectQueryVariables>(ItemsSelectDocument, options);
      }
export function useItemsSelectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ItemsSelectQuery, ItemsSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ItemsSelectQuery, ItemsSelectQueryVariables>(ItemsSelectDocument, options);
        }
export function useItemsSelectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ItemsSelectQuery, ItemsSelectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ItemsSelectQuery, ItemsSelectQueryVariables>(ItemsSelectDocument, options);
        }
export type ItemsSelectQueryHookResult = ReturnType<typeof useItemsSelectQuery>;
export type ItemsSelectLazyQueryHookResult = ReturnType<typeof useItemsSelectLazyQuery>;
export type ItemsSelectSuspenseQueryHookResult = ReturnType<typeof useItemsSelectSuspenseQuery>;
export type ItemsSelectQueryResult = Apollo.QueryResult<ItemsSelectQuery, ItemsSelectQueryVariables>;